/* tslint:disable */
/* eslint-disable */
export enum DriverLicenseTypeConditionalEnum {
  Limited = 'Limited',
  AlcoholInterlock = 'AlcoholInterlock',
  ZeroAlcohol = 'ZeroAlcohol'
}
